import frontLeftToeInCamberNegRed from './front-left_toe-in_camber-neg_red.jpg';
import frontLeftToeInCamberPosRed from './front-left_toe-in_camber-pos_red.jpg';
import frontLeftToeInCamberStraightRed from './front-left_toe-in_camber-straight_red.jpg';
import frontLeftToeOutCamberNegRed from './front-left_toe-out_camber-neg_red.jpg';
import frontLeftToeOutCamberPosRed from './front-left_toe-out_camber-pos_red.jpg';
import frontLeftToeOutCamberStraightRed from './front-left_toe-out_camber-straight_red.jpg';
import frontLeftToeStraightCamberNegRed from './front-left_toe-straight_camber-neg_red.jpg';
import frontLeftToeStraightCamberPosRed from './front-left_toe-straight_camber-pos_red.jpg';
import frontLeftToeStraightCamberStraightGray from './front-left_toe-straight_camber-straight_gray.jpg';
import frontLeftToeStraightCamberStraightGray1 from './front-left_toe-straight_camber-straight_gray1.jpg';
import frontLeftToeStraightCamberStraightGreen from './front-left_toe-straight_camber-straight_green.jpg';
import frontRightToeInCamberNegRed from './front-right_toe-in_camber-neg_red.jpg';
import frontRightToeInCamberPosRed from './front-right_toe-in_camber-pos_red.jpg';
import frontRightToeInCamberStraightRed from './front-right_toe-in_camber-straight_red.jpg';
import frontRightToeOutCamberNegRed from './front-right_toe-out_camber-neg_red.jpg';
import frontRightToeOutCamberPosRed from './front-right_toe-out_camber-pos_red.jpg';
import frontRightToeOutCamberStraightRed from './front-right_toe-out_camber-straight_red.jpg';
import frontRightToeStraightCamberNegRed from './front-right_toe-straight_camber-neg_red.jpg';
import frontRightToeStraightCamberPosRed from './front-right_toe-straight_camber-pos_red.jpg';
import frontRightToeStraightCamberStraightGray from './front-right_toe-straight_camber-straight_gray.jpg';
import frontRightToeStraightCamberStraightGray1 from './front-right_toe-straight_camber-straight_gray1.jpg';
import frontRightToeStraightCamberStraightGreen from './front-right_toe-straight_camber-straight_green.jpg';
import rearLeftToeInCamberNegRed from './rear-left_toe-in_camber-neg_red.jpg';
import rearLeftToeInCamberPosRed from './rear-left_toe-in_camber-pos_red.jpg';
import rearLeftToeInCamberStraightRed from './rear-left_toe-in_camber-straight_red.jpg';
import rearLeftToeOutCamberNegRed from './rear-left_toe-out_camber-neg_red.jpg';
import rearLeftToeOutCamberPosRed from './rear-left_toe-out_camber-pos_red.jpg';
import rearLeftToeOutCamberStraightRed from './rear-left_toe-out_camber-straight_red.jpg';
import rearLeftToeStraightCamberNegRed from './rear-left_toe-straight_camber-neg_red.jpg';
import rearLeftToeStraightCamberPosRed from './rear-left_toe-straight_camber-pos_red.jpg';
import rearLeftToeStraightCamberStraightGray from './rear-left_toe-straight_camber-straight_gray.jpg';
import rearLeftToeStraightCamberStraightGray1 from './rear-left_toe-straight_camber-straight_gray1.jpg';
import rearLeftToeStraightCamberStraightGreen from './rear-left_toe-straight_camber-straight_green.jpg';
import rearRightToeInCamberNegRed from './rear-right_toe-in_camber-neg_red.jpg';
import rearRightToeInCamberPosRed from './rear-right_toe-in_camber-pos_red.jpg';
import rearRightToeInCamberStraightRed from './rear-right_toe-in_camber-straight_red.jpg';
import rearRightToeOutCamberNegRed from './rear-right_toe-out_camber-neg_red.jpg';
import rearRightToeOutCamberPosRed from './rear-right_toe-out_camber-pos_red.jpg';
import rearRightToeOutCamberStraightRed from './rear-right_toe-out_camber-straight_red.jpg';
import rearRightToeStraightCamberNegRed from './rear-right_toe-straight_camber-neg_red.jpg';
import rearRightToeStraightCamberPosRed from './rear-right_toe-straight_camber-pos_red.jpg';
import rearRightToeStraightCamberStraightGray from './rear-right_toe-straight_camber-straight_gray.jpg';
import rearRightToeStraightCamberStraightGray1 from './rear-right_toe-straight_camber-straight_gray1.jpg';
import rearRightToeStraightCamberStraightGreen from './rear-right_toe-straight_camber-straight_green.jpg';
import iconAlignmentGreen from './QC-icon-Alignment-green.png';
import iconAlignmentGrey from './QC-icon-Alignment-grey.png';
import iconAlignmentRed from './QC-icon-Alignment-red.png';
import iconTireGreen from './QC-icon-Tire-green.png';
import iconTireGrey from './QC-icon-Tire-grey.png';
import iconTireRed from './QC-icon-Tire-red.png';
import iconTireOrange from './QC-icon-Tire-orange.png';
import iconTireYellow from './QC-icon-Tire-yellow.png';
import unknownCarImage from './unknownCarImage.png';
import unknownTireTread from './unknownTireTread.png';

/** Hunter tire images. Not all paths return an image so the output must be checked. */
export const images = {
    front: {
        left: {
            toe: {
                in: {
                    camber: {
                        pos: {
                            red: frontLeftToeInCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: frontLeftToeInCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: frontLeftToeInCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                out: {
                    camber: {
                        pos: {
                            red: frontLeftToeOutCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: frontLeftToeOutCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: frontLeftToeOutCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                straight: {
                    camber: {
                        pos: {
                            red: frontLeftToeStraightCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: frontLeftToeStraightCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: '',
                            gray: frontLeftToeStraightCamberStraightGray,
                            gray1: frontLeftToeStraightCamberStraightGray1,
                            green: frontLeftToeStraightCamberStraightGreen,
                        },
                    },
                },
            },
        },
        right: {
            toe: {
                in: {
                    camber: {
                        pos: {
                            red: frontRightToeInCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: frontRightToeInCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: frontRightToeInCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                out: {
                    camber: {
                        pos: {
                            red: frontRightToeOutCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: frontRightToeOutCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: frontRightToeOutCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                straight: {
                    camber: {
                        pos: {
                            red: frontRightToeStraightCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: frontRightToeStraightCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: '',
                            gray: frontRightToeStraightCamberStraightGray,
                            gray1: frontRightToeStraightCamberStraightGray1,
                            green: frontRightToeStraightCamberStraightGreen,
                        },
                    },
                },
            },
        },
    },
    rear: {
        left: {
            toe: {
                in: {
                    camber: {
                        pos: {
                            red: rearLeftToeInCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: rearLeftToeInCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: rearLeftToeInCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                out: {
                    camber: {
                        pos: {
                            red: rearLeftToeOutCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: rearLeftToeOutCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: rearLeftToeOutCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                straight: {
                    camber: {
                        pos: {
                            red: rearLeftToeStraightCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: rearLeftToeStraightCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: '',
                            gray: rearLeftToeStraightCamberStraightGray,
                            gray1: rearLeftToeStraightCamberStraightGray1,
                            green: rearLeftToeStraightCamberStraightGreen,
                        },
                    },
                },
            },
        },
        right: {
            toe: {
                in: {
                    camber: {
                        pos: {
                            red: rearRightToeInCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: rearRightToeInCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: rearRightToeInCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                out: {
                    camber: {
                        pos: {
                            red: rearRightToeOutCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: rearRightToeOutCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: rearRightToeOutCamberStraightRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                    },
                },
                straight: {
                    camber: {
                        pos: {
                            red: rearRightToeStraightCamberPosRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        neg: {
                            red: rearRightToeStraightCamberNegRed,
                            gray: '',
                            gray1: '',
                            green: '',
                        },
                        straight: {
                            red: '',
                            gray: rearRightToeStraightCamberStraightGray,
                            gray1: rearRightToeStraightCamberStraightGray1,
                            green: rearRightToeStraightCamberStraightGreen,
                        },
                    },
                },
            },
        },
    },
    icon: {
        tire: {
            green: iconTireGreen,
            grey: iconTireGrey,
            orange: iconTireOrange,
            red: iconTireRed,
            yellow: iconTireYellow,
        },
        alignment: {
            green: iconAlignmentGreen,
            grey: iconAlignmentGrey,
            red: iconAlignmentRed,
        },
    },
    unknownCarImage,
    unknownTireTread,
};
